<form class="event-form" [formGroup]="eventForm()">
  <ng-container formArrayName="sessions">
    @for (session of sessions.controls; track session; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="event-form__session">
          <mat-form-field class="event-form__input" appearance="fill">
            <mat-label for="name">Session Name</mat-label>
            <input
              matInput
              formControlName="name"
              placeholder="Session {{ i + 1 }}"
            />
            <div>
              @if (
                session.get("name")?.hasError("required") &&
                (session.get("name")?.dirty || session.get("name")?.touched)
              ) {
                <mat-error>Name is required.</mat-error>
              }
              @if (
                session.get("name")?.hasError("minlength") &&
                (session.get("name")?.dirty || session.get("name")?.touched)
              ) {
                <mat-error
                  >Minimum number of characters is
                  {{
                    session.get("name")?.errors?.["minlength"]?.[
                      "requiredLength"
                    ]
                  }}.</mat-error
                >
              }
              @if (
                session.get("name")?.hasError("maxlength") &&
                (session.get("name")?.dirty || session.get("name")?.touched)
              ) {
                <mat-error
                  >Maximum number of characters is
                  {{
                    session.get("name")?.errors?.["maxlength"]?.[
                      "requiredLength"
                    ]
                  }}.</mat-error
                >
              }
            </div>
          </mat-form-field>
          <button mat-fab (click)="removeSession(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </ng-container>
    }
  </ng-container>
  <button
    class="event-form__submit"
    mat-raised-button
    color="secondary"
    (click)="addSession()"
  >
    <mat-icon>add</mat-icon>
    Add Session
  </button>
</form>
